import { observer } from 'mobx-react-lite';
import { FC, useRef } from 'react';

import { CallMemberItem } from '@gem/call/popups/Permissions/Shared/CallMemberItem/CallMemberItem';
import { IcMoreIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconButton, IconViewSizes, PopoverMenu } from '@gem/ui-kit';

import { useCallSpeakerPermissionsItemPresenter } from './CallSpeakerPermissionsItem.presenter';
import styles from './CallSpeakerPermissionsItem.styles.m.css';
import { ICallSpeakerPermissionsItemProps } from './CallSpeakerPermissionsItem.types';

export const CallSpeakerPermissionsItem: FC<ICallSpeakerPermissionsItemProps> = observer(
  (props) => {
    const buttonRef = useRef<HTMLButtonElement>(null);
    const presenter = useCallSpeakerPermissionsItemPresenter(props);
    const { t } = useTranslation();

    return (
      <CallMemberItem
        userId={props.userId}
        call={props.call}
      >
        <div className={styles.label}>
          {t(presenter.member?.isMe ? 'call_initiator' : 'webinar_speaker')}
        </div>
        {!presenter.member?.isMe && (
          <IconButton
            Icon={IcMoreIcon}
            onClick={presenter.togglePopover}
            size={IconViewSizes.Big}
            iconSize={IconViewSizes.Medium}
            setRef={buttonRef}
          />
        )}
        <PopoverMenu
          className={styles.popover}
          isOpened={presenter.isPopoverOpened}
          placement="bottom-start"
          menuItems={presenter.menu}
          reference={buttonRef.current}
          onClose={presenter.closePopover}
          theme={'dark'}
        />
      </CallMemberItem>
    );
  }
);
